<script lang="ts">
	import {uqnArray} from './stores.js';
	import check from './check_random/check';
	import random from './check_random/random';
	import Textfield, {Input, Textarea} from '@smui/textfield';
	import Button, {Label, Icon} from '@smui/button';
	import Dialog, {Title, Content, Actions} from '@smui/dialog';
	import Slider from '@smui/slider';
	import FormField from '@smui/form-field';
	import Katex from './Katex.svelte';
	import Radio from '@smui/radio';
	import getRandomInt from './functions/getRandomInt';
	import uqnSplit from './functions/uqnSplit';
	import uqnJoin from './functions/uqnJoin';
	import QnComponent from './QnComponent.svelte';

	let uqnInput: number;
	let simpleDialog;
	
	let n:number, aSlide: number, a: number, bSlide: number, b: number;
	let cSlide: number, c: number, dSlide: number, d: number, eSlide: number, e: number, fSlide: number, f: number;
	let sign: number, signSlide: number;
	let n4: number;
	let _;

	// initialize
	let type = $uqnArray[0].toString()[0];
	
	$: _ = updateFromRadio(type);
	$: _ = updateFromUQN($uqnArray[0]);
	$: _ = updateType1Slider(n);
	$: _ = updateType23Slider(type,aSlide,bSlide,cSlide,dSlide,sign);
	$: _ = updateType4Slider(type,aSlide,bSlide,sign,n4);
	$: _ = updateType5Slider(type,aSlide,bSlide,cSlide,dSlide,eSlide,fSlide,sign);
	$: _ = updateType6Slider(type,aSlide,bSlide,cSlide,sign);
	
	function updateFromUQN(u:number){
		// type
		if (u > 999999){
			type = "5";
		} else{
			type = u.toString()[0];
		};
		// type specific
		if (type=="1"){
			n = Number(u.toString().slice(1));
		} else if (type=="2" || type=="3"){
			[_, aSlide,bSlide,cSlide,dSlide,sign] = uqnSplit(u);
			a = aSlide; b = bSlide; c = cSlide; d = dSlide;
			switch (sign){
				case 1:
					d *= -1;
					break;
				case 2:
					c *= -1;
					break;
				case 3:
					b *= -1;
					break;
				case 4:
					a *= -1;
					break;
				case 5:
					c *= -1; d *= -1;
					break
				case 6:
					b *= -1; d *= -1;
					break
				case 7:
					a *= -1; d *= -1;
					break
				case 8:
					c *= -1; b *= -1;
					break
				case 9:
					c *= -1; a *= -1;
					break
			}
		} else if (type=="4"){
			[_, aSlide,bSlide,sign,n4] = uqnSplit(u);
			if (sign%2==1){
				b *= -1;
			};
			if (sign>1){
				a *= -1;
			}
		} else if (type=="5"){
			[bSlide,aSlide,cSlide,dSlide,eSlide,fSlide,sign] = uqnSplit(u);
			a=aSlide; b=bSlide; c=cSlide; d=dSlide; e=eSlide; f=fSlide;
			switch (sign){
				case 1:
					d *= -1;
					break;
				case 2:
					c *= -1;
					break;
				case 3:
					b *= -1;
					break;
				case 4:
					a *= -1;
					break;
				case 5:
					f *= -1;
					break
				case 6:
					e *= -1;
					break
				case 7:
					b *= -1; d *= -1;
					break
				case 8:
					a *= -1; f *= -1;
					break
				case 9:
					b *= -1; c *= -1;
					break
			}
		} else if (type=="6"){
			[_,aSlide,bSlide,cSlide,sign] = uqnSplit(u);
			a=aSlide; b=bSlide; c=cSlide;
			if (sign==1){
				b*=-1;
			}
		}
	}

	function updateFromRadio(type:string){
		if (type=="5" && $uqnArray[0] < 999999){ // new linear eqn
			uqnInput = random(5);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="6" && ($uqnArray[0].toString().length == 7 || $uqnArray[0].toString()[0] != "6")){ // new quadratic eqn
			uqnInput = random(6);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="1"&& $uqnArray[0] > 199){ // new i^n
			uqnInput = random(1);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		};
		if (type=="2"){
			let uqnString = $uqnArray[0].toString();
			if (uqnString[0]=="1"||uqnString[0]=="6"||uqnString.length == 7){ // coming from i^n or linear or quadratic: start new qn
				uqnInput = random(2);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (uqnString[0]=="3"||uqnString[0]=="4"){ // coming from div/mult/powers: can reuse a,b,sign
				let newC: string, newD: string, newSign: string;
				if (uqnString[0]=="3"){
					newC = uqnString[3];
					newD = uqnString[4];
					newSign = uqnString[5]
				} else{
					newC = getRandomInt(1,9).toString();
					newD = getRandomInt(1,9).toString();
					newSign = uqnString[3]
				}
				uqnInput = uqnJoin([2,uqnString[1],uqnString[2],newC,newD,newSign]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			}
		}
		if (type=="3"){
			let uqnString = $uqnArray[0].toString();
			if (uqnString[0]=="1"||uqnString[0]=="6"||uqnString.length == 7){ // coming from i^n or linear or quadratic: start new qn
				uqnInput = random(3);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (uqnString[0]=="2"||uqnString[0]=="4"){ // coming from div/mult/powers: can reuse a,b,sign
				let newC: string, newD: string, newSign: string;
				if (uqnString[0]=="2"){
					newC = uqnString[3];
					newD = uqnString[4];
					newSign = uqnString[5]
				} else{
					newC = getRandomInt(1,9).toString();
					newD = getRandomInt(1,9).toString();
					newSign = uqnString[3]
				}
				uqnInput = uqnJoin([3,uqnString[1],uqnString[2],newC,newD,newSign]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			}
		}
		if (type=="4"){
			let uqnString = $uqnArray[0].toString();
			if (uqnString[0]=="1"||uqnString[0]=="6"||uqnString.length == 7){ // coming from i^n or linear or quadratic: start new qn
				uqnInput = random(4);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			} else if (uqnString[0]=="2"||uqnString[0]=="3"){ // coming from div/mult/powers: can reuse a,b,sign
				let newC: string, newD: string, newSign: string;
				newC = uqnString[3];
				newD = uqnString[4];
				newSign = uqnString[5]
				uqnInput = uqnJoin([4,uqnString[1],uqnString[2],newC,newD,newSign]);
				uqnArray.update( original => [uqnInput, ...original.slice(1)])
			}
		}
	}

	function updateType1Slider(n1:number){
		uqnInput = 100+n1;
		uqnArray.update( original => [uqnInput, ...original.slice(1)])
	}

	function updateType4Slider(type:string,a2:number, b2:number, sign2: number, n2:number){
		if (type=="4"){
			if (a2==0){
				a2 = 1;
				aSlide = a2;
			}
			if (b2==0){
				b2 = 1;
				bSlide = b2;
			}
			a = a2; b=b2;
			if (sign2%2==1){
				b *= -1;
			};
			if (sign2>1){
				a *= -1;
			}
			uqnInput = uqnJoin([type,a2,b2,sign2,n2]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		}
	}

	function updateType6Slider(type:string,a2:number, b2:number, c2:number,sign2: number){
		if (type=="6"){
			if (a2==0){
				a2 = 1;
			}
			if (c2==0){
				c2 = 1;
			}
			if (b2*b2-4*a2*c2 >= 0){
				console.log(a2,b2,c2);
				if (a2 != Number($uqnArray[0].toString()[1])){ // a is last slider to change. 
					while(b2*b2-4*a2*c2 >= 0){
						b2 = getRandomInt(0,9);
						c2 = getRandomInt(1,9);
					}
				} else if (b2 != Number($uqnArray[0].toString()[3])){ // b is last slider to change. 
					while(b2*b2-4*a2*c2 >= 0){
						a2 = getRandomInt(1,9);
						c2 = getRandomInt(1,9);
					}
				} else{
						while(b2*b2-4*a2*c2 >= 0){
							b2 = getRandomInt(0,9);
							a2 = getRandomInt(1,9);
						}
				}
			}
			aSlide = a2; cSlide = c2; bSlide = b2;
			a = a2; b=b2; c=c2;
			if (sign2==1){
				b *= -1;
			};
			uqnInput = uqnJoin([type,a2,b2,c2,sign2]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		}
	}

	function updateType23Slider(type:string,a2:number,b2:number,c2:number,d2:number,sign2:number){
		if (type=="2" || type=="3"){
			if (a2==0&&b2==0){
				if ($uqnArray[0].toString()[1]=="0"){ // a was originally 0
					a2 = getRandomInt(1,9);
					aSlide = a2;
				} else{
					b2 = getRandomInt(1,9);
					bSlide = b2;
				}
			}
			if (c2==0&&d2==0){
				if ($uqnArray[0].toString()[3]=="0"){ // c was originally 0
					c2 = getRandomInt(1,9);
					cSlide = c2;
				} else{
					d2 = getRandomInt(1,9);
					dSlide = d2;
				}
			}
			if (b2==0&&d2==0){
				if ($uqnArray[0].toString()[2]=="0"){ // b was originally 0
					b2 = getRandomInt(1,9);
					bSlide = b2;
				} else{
					d2 = getRandomInt(1,9);
					dSlide = d2;
				}
			}
			a = a2; b=b2; c=c2; d=d2;
			switch (sign2){
				case 1:
					d *= -1;
					break;
				case 2:
					c *= -1;
					break;
				case 3:
					b *= -1;
					break;
				case 4:
					a *= -1;
					break;
				case 5:
					c *= -1; d *= -1;
					break
				case 6:
					b *= -1; d *= -1;
					break
				case 7:
					a *= -1; d *= -1;
					break
				case 8:
					c *= -1; b *= -1;
					break
				case 9:
					c *= -1; a *= -1;
					break
			}		
			uqnInput = uqnJoin([type,a2,b2,c2,d2,sign2]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		}
	}

	function updateType5Slider(type:string,a2:number,b2:number,c2:number,d2:number,e2:number,f2:number,sign2:number){
		if (type=="5"){
			if (b2==0){
				b2=1;
				bSlide=b2;
			}
			if (c2==0&&d2==0){
				if ($uqnArray[0].toString()[2]=="0"){ // c was originally 0
					c2 = getRandomInt(1,9);
					cSlide = c2;
				} else{
					d2 = getRandomInt(1,9);
					dSlide = d2;
				}
			}
			if (e2==0&&f2==0){
				if ($uqnArray[0].toString()[4]=="0"){ // e was originally 0
					e2 = getRandomInt(1,9);
					eSlide = e2;
				} else{
					f2 = getRandomInt(1,9);
					fSlide = f2;
				}
			}
			if (f2==0&&d2==0){
				if ($uqnArray[0].toString()[3]=="0"){ // d was originally 0
					d2 = getRandomInt(1,9);
					dSlide = d2;
				} else{
					f2 = getRandomInt(1,9);
					fSlide = f2;
				}
			}
			a = a2; b=b2; c=c2; d=d2; e =e2; f=f2;
			switch (sign2){
				case 1:
					d *= -1;
					break;
				case 2:
					c *= -1;
					break;
				case 3:
					b *= -1;
					break;
				case 4:
					a *= -1;
					break;
				case 5:
					f *= -1;
					break
				case 6:
					e *= -1;
					break
				case 7:
					b *= -1; d *= -1;
					break
				case 8:
					a *= -1; f *= -1;
					break
				case 9:
					b *= -1; c *= -1;
					break
			}
			uqnInput = uqnJoin([b2,a2,c2,d2,e2,f2,sign2]);
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		}
	}

	function uqnClick(){
		if (check(uqnInput)){
			uqnArray.update( original => [uqnInput, ...original.slice(1)])
		} else{
			simpleDialog.open();
		}
	}	

</script>

<h2>Options</h2>
<hr>
<h3>UQN</h3>
<p>
	Retrieve a question by keying in a UQN (3-7 digits):
</p>
<Textfield class="shaped-outlined" variant="outlined" bind:value={uqnInput} label="UQN" type="number"/>
<Button on:click={uqnClick} variant="unelevated" class="button-shaped-round">
	<Label>Generate question</Label>
</Button>
<hr>
<h3>
	Question construction tools
</h3>
<p> 
	Use the options below to modify question (a)
</p>
<QnComponent uqn={$uqnArray[0]}/>
<hr>
<div>
	<p>First choose the general type of question:</p>
	<FormField>
		<Radio bind:group={type} value=1/>
		<span slot="label"><Katex math="i^n"/></span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=2/>
	<span slot="label">Multiplication</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=3/>
		<span slot="label">Division</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=4/>
		<span slot="label">Powers</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=5/>
		<span slot="label">Linear Equation</span>
	</FormField>
	<FormField>
		<Radio bind:group={type} value=6/>
		<span slot="label">Quadratic Equation</span>
	</FormField>
</div>
<hr>
{#if type=="1"}
<p>We will be evaluating <Katex math="i^n"/></p>
{:else if type=="2"}
<p>We will be evaluating <Katex math="(a+bi)(c+di)"/></p>
{:else if type=="3"}
<p>We will be evaluating <Katex math={"\\displaystyle \\frac{a+bi}{c+di}"}/></p>
{:else if type=="4"}
<p>We will be evaluating <Katex math="(a+bi)^n"/></p>
{:else if type=="5"}
<p>We will be solving <Katex math={"(a+bi)z + (c+di) = e+fi"}/></p>
{:else if type=="6"}
<p>We will be solving <Katex math={"az^2+bz+c=0"}/></p>
{/if}
<p>
	Use the sliders belows to choose different options to craft your own unique question.
</p>
{#if type=="1"}
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={n} min={0} max={99} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"n="+n.toString()}/></span>
	</FormField>
</div>
{:else}
<div>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={aSlide} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"a="+a.toString()}/></span>
	</FormField>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={bSlide} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"b="+b.toString()}/></span>
	</FormField>
</div>
{/if}
{#if type=="2" || type=="3" || type=="5" || type=="6"}
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={cSlide} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"c="+c.toString()}/></span>
	</FormField>
	{#if type != "6"}
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={dSlide} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"d="+d.toString()}/></span>
		</FormField>
		{#if type=="5"}
			<FormField align="end" style="display: flex; width: 90%" >
				<Slider bind:value={eSlide} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
				<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"e="+e.toString()}/></span>
			</FormField>
			<FormField align="end" style="display: flex; width: 90%" >
				<Slider bind:value={fSlide} min={0} max={9} step={1} style="width:80%" discrete displayMarkers/>
				<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"f="+f.toString()}/></span>
			</FormField>
		{/if}
		<p>This last slider modifies the signs of some of the constants above</p>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={sign} min={0} max={9} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">Modify signs</span>
		</FormField>
	{:else}
		<p>This last slider modifies the sign of <Katex math="b"/></p>
		<FormField align="end" style="display: flex; width: 90%" >
			<Slider bind:value={sign} min={0} max={1} step={1} style="width:80%" displayMarkers/>
			<span slot="label" style="padding-right: 12px; width: max-content; display: block;">Modify sign</span>
		</FormField>
	{/if}
{/if}
{#if type=="4"}
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={n4} min={2} max={3} step={1} style="width:80%" discrete displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;"><Katex math={"n="+n4.toString()}/></span>
	</FormField>
	<p>This last slider modifies the signs of some of the constants above</p>
	<FormField align="end" style="display: flex; width: 90%" >
		<Slider bind:value={sign} min={0} max={3} step={1} style="width:80%" displayMarkers/>
		<span slot="label" style="padding-right: 12px; width: max-content; display: block;">Modify signs</span>
	</FormField>
{/if}


<Dialog bind:this={simpleDialog}>
	<!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
	<Title>Invalid UQN</Title>
	<Content>
		You have keyed an invalid UQN. Please try again.
	</Content>
	<Actions>
		<Button>
			<Label>OK</Label>
		</Button>
	</Actions>
</Dialog>
<hr>